// src/utils/assets.js
//
// Resolve a public asset filename to its full URL. When REACT_APP_ASSETS_URL
// is configured (production, staging), assets are served from S3 (or
// CloudFront once we migrate). If the env var is unset (local dev without
// AWS credentials), fall back to the provided local path so nothing breaks.
//
// Usage:
//   import { assetUrl } from '../utils/assets';
//   const src = assetUrl('mergeVideo.mov', '/videos/mergeVideo.mp4');
//   // → 'https://dublabs-assets.s3.us-east-1.amazonaws.com/mergeVideo.mov'
//   //   or '/videos/mergeVideo.mp4' if REACT_APP_ASSETS_URL is empty

const BASE = (process.env.REACT_APP_ASSETS_URL || '').replace(/\/$/, '');

export function assetUrl(filename, fallback) {
  if (BASE) return `${BASE}/${filename.replace(/^\//, '')}`;
  return fallback || `/${filename}`;
}
